import {
  hasPaywallFeatureStateResolved,
  isPaywallUnlocked,
  PaywallFeature
} from '@canvas/paywall';

/**
 * Returns whether the current site has resolved entitlement to use Database Rovo.
 *
 * This is intentionally limited to the tenant-level entitlement. Product
 * experiments and feature flags remain owned by their individual UI surfaces.
 */
export const isDatabaseRovoAvailable = (): boolean =>
  hasPaywallFeatureStateResolved() && isPaywallUnlocked(PaywallFeature.AI_TEAMMATE);
